//////////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import { _SETTINGS } from 'config/settings';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

///////////////////////////////////////////////////////////   ICONS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faClock, faCheckCircle, faExclamationCircle, faUser, faUserTie, faHouseUser } from '@fortawesome/free-solid-svg-icons'; //faPaperPlane
import { ButtonGroup } from 'react-bootstrap';
///////////////////////////////////////////////////////////   SCSS
import './comment-panel.styles.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
///////////////////////////////////////////////////////////   INTERFACE
export interface Comment {
  endPoint: any;
  mainVideo: any;
  userConfig: any;
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class CommentPanel extends React.Component<any, { [key: string]: any }> {
  private refComment: React.RefObject<any>;
  constructor(props: any) {
    super(props);
    this.state = {
      ...this.props,
      sortCommentsDesc: true,
      mainVideo: this.props.mainVideo,
      getReviewUrl: null,
      postReviewUrl: null,
      reviewData: null,
      commentData: null,
      userConfig: null,
      respIdle: false,
      recipientList: null,
      lista: null,
      type: null
    };
    this.refComment = React.createRef();
  }

  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  /**
   * Update comment in 1 sec
   */
  private revUpdater: any = setInterval(() => {
    this.getReview();
  }, 10000);

  componentDidMount() {
    this.getReview();
    //this.getRecipientList();
  }
  componentWillUnmount() {
    clearInterval(this.revUpdater);
  }

  componentDidUpdate(prevProps: Comment) {
    if (this.props !== prevProps) {
      this.setState({ ...this.props });
    }
    if (this.props.endPoint !== prevProps.endPoint) {
      this.setState({ endPoint: this.props.endPoint });
    }
    if (this.props.mainVideo !== prevProps.mainVideo) {
      this.setState({ mainVideo: this.props.mainVideo });
    }
    if (this.props.userConfig !== prevProps.userConfig) {
      this.setState({ userConfig: this.props.userConfig });
    }
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS

  /**
   * Get review
   * Get all review data, and comments from TAU and save all info to state
   * https://tautest/taudev/api/index.php?&wtd=apihelp&endPoint=review&method=getReviewHistory
   *
   */
  private getReview = () => {
    try {
      const { mainVideo, endPoint } = this.state;

      let recordID: number | null = mainVideo.proxyData.recordID;
      recordID &&
        axios
          .get(endPoint.getReviewUrl + recordID, { withCredentials: true })
          .then((res) => {
            this.setState({ reviewData: res.data.result });
          })
          .catch((err) => {
            console.log(_SETTINGS.err.reviewGet, err);
          });
    } catch (err) {
      console.log(_SETTINGS.err.review, err);
    }
  };

  /**
   * Set review data for TAU
   * TAU webservice API for set review: https://tautest/taudev/api/index.php?&wtd=apihelp&endPoint=review&method=setReview
   */
  private setReview = async (iconState: number) => {
    try {
      const { mainVideo, userConfig, endPoint } = this.state; // reviewData
      let formComment = document.getElementById('formComment') as HTMLInputElement,
        recordID: number | null = mainVideo.proxyData.recordID,
        revData = {
          reviewData: {
            reviewID: 0,
            userID: userConfig?.userID,
            recordID: recordID,
            reviewStateID: iconState,
            notes: formComment.value ? formComment.value : ''
          }
        };
      this.setState({ respIdle: true });
      await this.postData(endPoint.postReviewUrl, revData); // res.text(); // data ? data.text() ? data.json()
      this.getReview();
      this.setState({ commentData: null, respIdle: false });
      formComment.value = '';
    } catch (err) {
      console.log(_SETTINGS.err.review, err);
    }
  };
  /**
   * Post data
   * Posts data for TAU by TAU API
   * We can use axios for this, but we need to use fetch for now
   * @param url TAU post comment url
   * @param data return data for TAU comment
   * @returns async respons
   */
  private postData = async (url: string = '', data = {}) => {
    // TODO:: add axios.CancelTokens
    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        cache: 'default',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        body: JSON.stringify(data)
      });
      return response;
    } catch (err) {
      console.log(_SETTINGS.err.reviewPost, err);
    }
  };

  /**
   * Switch icons
   * Switch between TAU recordReviewStateID's states: 0 – nincs, 1 – elfogadva, 2 – reklamáció, 3 – elutasítva
   * @param iconState: number, recordReviewStateID
   * @returns
   */
  private switchIcons = (iconState: number): JSX.Element => {
    switch (iconState) {
      case 1: {
        return <FontAwesomeIcon icon="check-circle" />;
      }
      case 2: {
        return <FontAwesomeIcon icon="exclamation-circle" />;
      }
      case 3: {
        return <FontAwesomeIcon icon="ban" />;
      }

      default: {
        return <></>;
      }
    }
  };
  private switchDesign = (iconState: number): string | null => {
    switch (iconState) {
      case 1:
        return 'success';
      case 2: {
        return 'warning';
      }
      case 3: {
        return 'danger';
      }

      default: {
        return null;
      }
    }
  };

  /**
   * Handle Comment Change
   */
  private handleCommentChange = (txt: any = '') => {
    this.setState({ commentData: txt?.target.value });
  };
  /**
   * Display comments
   * @returns JSX.Element
   */
  private displayComments = (): any => {
    const { reviewData, sortCommentsDesc } = this.state;
    if (!reviewData?.review) return <></>;
    return reviewData.review
      .sort((a: any, b: any) => {
        let x: any = new Date(a.reviewData.date),
          y: any = new Date(b.reviewData.date);
        return sortCommentsDesc ? y - x : x - y;
      })
      .map((v: any, k: number) => {
        let id = v.reviewData.reviewStateID,
          name = v.reviewData.userName,
          date = v.reviewData.date,
          notes = v.reviewData.notes;
        return (
          <div key={k} className={'comment ' + this.switchDesign(id)}>
            <div className='comment__header'>
              <div className='title'>
                <span className={'header-comment-icon ' + this.switchDesign(id)}>{this.switchIcons(id)}</span>
                <span className='userName'>{name}</span>
              </div>
              <div className='date'>
                <FontAwesomeIcon icon="clock" /> {date}
              </div>
            </div>
            <div className='comment__content'>
              <span className='text'>{notes}</span>
            </div>
          </div>
        );
      });
  };


  getRecipientList = (): any => {
    const { reviewData, type } = this.state;

    let list = Array(reviewData?.notices[type]?.data);
    let ico: any;

    return <div>
      <span className='ertesites-title'>{reviewData?.notices[type]?.label} </span>

      {Object.keys(list).map((keyOuter: any) => {
        return Object.keys(list[keyOuter]).map((keyInner: any) => {

          if (list[keyOuter][keyInner].icon == "mtva") {
            ico = <FontAwesomeIcon icon="house-user" />
          } else if (list[keyOuter][keyInner].icon == "partner") {
            ico = <FontAwesomeIcon icon="user-tie" />
          } else {
            ico = <FontAwesomeIcon icon="user" />
          }
          return (
            <span key={`${keyInner}-${keyOuter}`} className="badge bg-warning me-1 recipient">
              {ico}
              {list[keyOuter][keyInner].name}
            </span>

          );
        });
      })}

    </div>
  }


  recipientUpdate = (nr: number) => {
    this.setState({ type: nr })
  }


  ///////////////////////////////////////////////////////////   RENDER
  render() {
    const { commentData, respIdle, reviewData, type } = this.state;
    return (
      <>
        <div className='commentForm'>
          <Form.Group className='mb-3 text-start' controlId='formComment'>
            <Form.Label>Új hozzászólás</Form.Label>
            <Form.Control as='textarea' rows={2} placeholder='Hozzászólás szövege' onChange={(txt) => this.handleCommentChange(txt)} />
          </Form.Group>
          <ButtonGroup className='comment-group'>
            <Button bsPrefix='comment-icon danger' onMouseOver={() => this.recipientUpdate(3)} onClick={() => this.setReview(3)} disabled={!respIdle ? false : true}>
              Elutasítom
              <FontAwesomeIcon icon="ban" />
            </Button>
            <Button bsPrefix='comment-icon warning' onMouseOver={() => this.recipientUpdate(2)} onClick={() => this.setReview(2)} disabled={!respIdle && commentData?.length ? false : true}>
              Megjegyzés
              <FontAwesomeIcon icon="exclamation-circle" />
            </Button>

            <Button bsPrefix='comment-icon success' onMouseOver={() => this.recipientUpdate(1)} onClick={() => this.setReview(1)} disabled={!respIdle ? false : true}>
              Elfogadom
              <FontAwesomeIcon icon="check-circle" />
            </Button>
          </ButtonGroup>
          <div id='recipients-holder' className='recipients-holder'>
            {type > 0 ? <this.getRecipientList /> : null}


          </div>
        </div>
        {<this.displayComments />}
      </>
    );
  }
}
